import styled from 'styled-components'
import { GRAYSCALE_300, NEUTRAL_300 } from '@styles/colors'
import { INTER } from '@styles/fonts'

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  color: black;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
  overflow-y: auto;
  height: 100%;
`

export const LanguageTitle = styled.span`
  color: ${NEUTRAL_300};
  font-size: 14px;
  font-family: ${INTER.semiBold};
  padding: 12px 12px;
`

export const LanguageListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 12px 12px;
`

export const LanguageItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 0;
  cursor: pointer;
`

export const LanguageInfo = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`

export const LanguageIcon = styled.img`
  /* Add any specific styling for the language icon if needed */
`

export const LanguageName = styled.span`
  /* Add any specific styling for the language name if needed */
`

export const Divider = styled.div`
  height: 1px;
  background-color: ${GRAYSCALE_300};
`
